<template>
  <div id="verification-question-screen">
    <div class="col-sm-6">
      <div class="row ml-20 mb-20">
        <h4 class="question-title">{{questionTitle}}</h4>
      </div>
      <div class="row ml-20 mb-20">
        <span class="question-title">{{model.identifier}}</span>
        <span class="category-tag">{{model.criteria_category.name}}</span>
        <p class="question-name-field">{{model.name}}</p>
      </div>
      <div class="row ml-20 mb-20">
        <span>{{$t('app.verification_questions.legalDescriptionTitle')}}</span>
        <p class="legal-description">{{model.legal_description? model.legal_description : $t('app.verification_questions.missing')}}</p>
      </div>
      <div class="row ml-20 mb-20">
        <span>{{$t('app.verification_questions.legalRerenceTitle')}}</span>
        <p class="legal-reference">{{model.legal_reference}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationQuestionScreen',
  props: {
    model: {
      type: Object,
      required: true,
    },
    questionTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.question-title {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/VerificationQuestionScreen.vue